import React from 'react';

import { ECompanyType } from '~/src/dash/api/company';
import { IPublisher } from '~/src/dash/api/console-api';
import { CompanyMultiSelect } from '~/src/dash/components/dropdowns/company-multi-select';
import { FocusedTextfield } from '~/src/dash/components/focused-textfield';
import { ButtonV2, Col, Cols, Row, Rows, Text } from '~/src/dash/publicaUI';
import { IUserState } from '~/src/dash/reducers/user-reducers';

// component note: this is used to popup and prompt the user to create a global mediafile or vast
// for a creative via name and url

interface IProps {
  newCreateBannerName: string;
  newCreateBannerURL: string;
  // handles change in name or url
  handleChangeBanner: (event: any) => void;
  // creates the asset/vast from this form
  handleCreateBannerFromURL: () => void;
  buttonClass: any;
  publisher: IPublisher;
  handleChangeBannerAdvertiser?: (advertiserIDs: number[]) => void;
  advertiserID?: number;
  user: IUserState;
}

export const CreateBannerModal = (props: IProps) => {
  const {
    newCreateBannerName,
    newCreateBannerURL,
    handleChangeBanner,
    handleCreateBannerFromURL,
    handleChangeBannerAdvertiser,
    buttonClass,
    publisher,
    advertiserID,
  } = props;
  const shouldDisplayAdvertiserFields =
    handleChangeBannerAdvertiser && (advertiserID || advertiserID === 0);
  return (
    <Rows>
      <Row extraLargePadding>
        <Text extraLarge bold>
          Create Banner Asset from URL
        </Text>
      </Row>
      <Row hugeHorizontalPadding>
        <Text>Enter a valid URL for an image file to create an asset</Text>
      </Row>
      <Row hugeHorizontalPadding>
        <Cols>
          <Col>
            <Text>Asset Name</Text>
          </Col>
          <Col largeHorizontalPadding>
            <FocusedTextfield
              name={'newCreateBannerName'}
              multiline
              value={newCreateBannerName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeBanner(event);
              }}
              style={{
                minWidth: '512px',
              }}
            />
          </Col>
        </Cols>
      </Row>
      <Row hugeHorizontalPadding>
        <Cols>
          <Col>
            <Text>URL</Text>
          </Col>
          <Col largeHorizontalPadding>
            <FocusedTextfield
              name={'newCreateBannerURL'}
              multiline
              value={newCreateBannerURL}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                handleChangeBanner(event);
              }}
              style={{
                minWidth: '512px',
              }}
            />
          </Col>
        </Cols>
      </Row>
      {shouldDisplayAdvertiserFields && (
        <Row hugeHorizontalPadding>
          <Cols>
            <Col>
              <Text>Advertiser</Text>
            </Col>
            <Col largeHorizontalPadding>
              <CompanyMultiSelect
                onChange={handleChangeBannerAdvertiser}
                publisherID={publisher.ID}
                companyIDs={[advertiserID]}
                enableMultiSelect={false}
                companyTypesAllowed={[
                  ECompanyType.TYPE_ADVERTISER,
                  ECompanyType.TYPE_AD_NETWORK,
                  ECompanyType.TYPE_HOUSE_ADVERTISER,
                ]}
                counter={0}
                maxHeight={150}
                username={props.user.user.Username}
              />
            </Col>
          </Cols>
        </Row>
      )}
      <Row extraLargeHorizontalPadding>
        <ButtonV2 color='primary' onClick={handleCreateBannerFromURL} className={buttonClass}>
          + Create Asset
        </ButtonV2>
      </Row>
    </Rows>
  );
};
